// Libs
import React from 'react';
import useTheme from 'hooks/useTheme';
// Components
import IconButton from '@mui/material/IconButton';
import Icon from './Delete';

const DeleteIcon = ({ onClick, color, onlyIcon }) => {
	const { theme } = useTheme();

	return onlyIcon ? (
		<Icon fill={color || theme._highEmphasisColor} onClick={onClick} />
	) : (
		<IconButton onClick={onClick}>
			<Icon fill={color || theme._highEmphasisColor} />
		</IconButton>
	);
};

export default DeleteIcon;
